import { Injectable, inject } from '@angular/core';

import { Observable, filter, map, switchMap } from 'rxjs';

import { LanguageService } from '@fcom/ui-translate';
import { CmsDataService } from '@fcom/core/services/cms/cms-data.service';
import { MonitoringLogger } from '@fcom/core/services/monitoring/monitoring-logger';
import { finShare } from '@fcom/rx';
import { recursiveParse } from '@fcom/cms/services/cms-utils/cms-utils';
import { CmsCollection, CmsContent, CmsContentType, CmsPicture } from '@fcom/core-api/interfaces/cms-interface';

@Injectable()
export class FragmentService {
  private languageService = inject(LanguageService);
  private cmsDataService = inject(CmsDataService);
  private monitoringLogger = inject(MonitoringLogger);

  getFragment<T>(fragmentKey: string, extraParams?: Record<string, string>): Observable<T> {
    return this.languageService.translate(fragmentKey).pipe(
      filter(Boolean),
      switchMap((url) => this.cmsDataService.getFragmentJson<T>(url, extraParams)),
      map((data) => {
        if (data['contentId']) {
          return recursiveParse(data as CmsContent | CmsCollection, this.monitoringLogger) as T;
        }
        return data;
      }),
      finShare()
    );
  }

  getCmsPictureFromFragment(fragmentKey: string): Observable<CmsPicture> {
    return this.getFragment<{ picture?: CmsPicture }>(`${fragmentKey}.url`).pipe(
      filter((fragment) => {
        if (!fragment?.picture || fragment.picture.contentType !== CmsContentType.CMPicture) {
          this.monitoringLogger.error(`Missing picture for fragment ${fragmentKey}.`);
          return false;
        }

        return true;
      }),
      map(({ picture }) => picture)
    );
  }
}
